import { Injector } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

export abstract class DialogAbstractComponent {
  dialogParams: any;
  dialogRef: any;

  constructor(injector: Injector) {
    this.dialogParams = injector.get(MAT_DIALOG_DATA);
    this.dialogRef = injector.get(MatDialogRef);
  }

  closeDialog(data?: any) {
    this.dialogRef.close({ status: 'close', data });
  }

  cancelDialog(data?: any) {
    this.dialogRef.close({ status: 'cancel', data });
  }
}
